<template>
  <base-slide-over ref="slideOver" title="Filter History" size="lg">
    <div class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6">
      <div class="tw-text-normal tw-font-normal tw-mb-2.5">Event Type</div>
      <base-list-group>
        <base-list-item v-for="(eventType, index) in eventTypes" :key="eventType.title" :show-bottom-border="index != eventTypes.length - 1">
          <base-checkbox :label="eventType.title" :value="eventType.value" v-model="eventTypesFilter" />
        </base-list-item>
      </base-list-group>
    </div>
    <template #fixed-bottom>
      <div class="tw-p-3 tw-flex tw-justify-between">
        <base-button type="flat" color="red" class="tw-w-auto tw-mr-2" @click="clearFilters">
          Clear All
        </base-button>
        <div>
          <base-button type="flat" class="tw-w-auto tw-mr-2" @click="$refs.slideOver.hide()">
            Cancel
          </base-button>
          <base-button class="tw-w-auto" @click="applyFilter">
            Apply
          </base-button>
        </div>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { mapGetters } from "vuex";
import { cloneDeep } from "lodash";

export default {
  data() {
    return {
      eventTypesFilter: [],
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    eventTypes() {
      return [
        { title: "Charge", value: "charge" },
        { title: "Refund", value: "refund" },
        ...(this.organization.useCreditsSetting ? [{ title: "Credit", value: "credit" }] : []),
        { title: "Plan Change", value: "planchange" },
        { title: "Comments", value: "comment" },
        { title: "Credit Card", value: "creditcard" },
        ...(this.organization.usePrescriptionProgramSetting ? [{ title: "Rx History", value: "rxhistory" }] : []),
        ...(this.organization.useTodoSetting ? [{ title: "Activities", value: "todo" }] : []),
        { title: "Profile Updated", value: "memberhistory" },
        { title: "Address Changed", value: "addresschanged" },
        { title: "Receipt Sent To Patient", value: "receiptsenttopatient" },
        { title: "Shipment Notification Sent", value: "shipmentnotificationsent" },
      ];
    },
  },
  methods: {
    show(filter) {
      this.eventTypesFilter = cloneDeep(filter);
      this.$refs.slideOver.show();
    },
    hide() {
      this.$refs.slideOver.hide();
    },
    clearFilters() {
      this.reset();
      this.applyFilter();
    },
    reset() {
      this.eventTypesFilter = [];
    },
    applyFilter() {
      this.$emit("filter-updated", {
        eventTypesFilter: this.eventTypesFilter,
      });

      this.hide();
    },
  },
};
</script>
